import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { AuthService } from '@app/service/auth.service';

@Injectable()
class BasicAuthInterceptor implements HttpInterceptor 
{
    constructor
    (
        private authService: AuthService
    ) 
    { }

    intercept
    (
        request: HttpRequest<any>, 
        next: HttpHandler
    ): Observable<HttpEvent<any>> 
    {
        let user;
        let isLoggedIn;
        let isApiUrl;
        let isSsoAuthorize;

        let sessionId;
        let headers;

        user = this.authService.userValue;
        isLoggedIn = (user != null);
        isApiUrl = request.url.startsWith(environment.apiUrl);
        isSsoAuthorize = request.url.includes('/user/ssoAuthorize');
        sessionId = this.authService.cypherSessionId;

        if (!sessionId && user && user.sessionId)
        {
            sessionId = user.sessionId;
        }

        headers = {};

        if (sessionId)
        {
            headers['X-Cypher-Session-Id'] = sessionId;
        }

        if (isLoggedIn && isApiUrl && !isSsoAuthorize) 
        {
            request = request.clone(
            {
                withCredentials: true,
                setHeaders: headers
            });
        }
        else if (isApiUrl && !isSsoAuthorize)
        {
            request = request.clone(
            {
                withCredentials: true,
                setHeaders: headers
            });
        }
        
        return next.handle(request);
    }
}
export { BasicAuthInterceptor }